import { useEffect, useState } from 'react';
import { useData } from '../context/DataContext';

type DataByIdEffectProps = {
  idName?: string;
  idValue?: string | undefined;
  tableName: string;
};

export const useDataByIdEffect = <T>(input: DataByIdEffectProps) => {
  const { idName = 'id', idValue, tableName } = input;
  const [data, setData] = useState<Partial<T>>({});
  const { supabase } = useData();
  useEffect(() => {
    async function fetchData() {
      const { data, error } = await supabase
        .from(tableName)
        .select('*')
        .eq(idName, idValue);
      if (error) {
        console.error(error);
        return [];
      }
      return data ?? [];
    }
    fetchData().then((data) => setData(data[0] as T));
  }, [idName, idValue, supabase, tableName]);
  return {
    data,
    setData,
  };
};
